import Vue from 'vue'
import FxList from '@/wikaz-core/ui/composants/list/FxList'
import FxListSimple from '@/wikaz-core/ui/composants/list/FxListSimple'
import FxExportButton from '@/wikaz-core/ui/composants/list/FxExportButton'
Vue.component('fx-list', FxList)
Vue.component('fx-list-simple', FxListSimple)
Vue.component('fx-export-button', FxExportButton)